<template>
  <div class="data_brain_wrap">
    <div class="card_wrap" >
      <div class="fenlei">
        <div
          v-for="(item, index) in hqtypes"
          :key="index"
          class="fenleilist"
          :class="['item', index === currentTab ? 'active' : '']"
          @click.stop="wzxslist(item, index)">
          {{ item.name }}
        </div>
      </div>

    
        <!-- <div
            style="width: 33%; height: 33%"
            v-for="(item, index) in pics"
            :key="index">
            <el-image
              :src="item.pic"
              style="height: 100%; width: 100%"
              :preview-src-list="pics"></el-image>
          </div> -->
        <el-row :gutter="10">
          <el-col :span="8" v-for="(item, index) in pics" :key="index" :xs="12" :md="8">
				<div style="font-weight: 700;margin-bottom: 0.2vw;color: #111;">{{item.title}}</div>
              <el-image  :src="item.pic" fit="cover" lazy style="width: 100%;height: 12vw;"></el-image>
            
          </el-col>
        </el-row>
    </div>
  </div>
</template>

<script>
import { getExcelImg, HqType } from "@/api/user.js";
export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 5, // 每页显示的卡片数量
      cardlist: [],
      // 所有数据
      allData: [],
      qiyeData: [],
      articleType: [],
      content: "",
      cardinfo: [],
      userInfo: [],
      count: 0,
      cid: 0,
      zbtype: [],
      pagenum: 1,
      qiyeType: [],
      qydetail: [],
      qyshop: [],
      qytypes: [],
      pics: [],
      currentTab: 0,
      hqtypes: [],
      typeid: 1,
      // wzcontent:""
    };
  },
  computed: {
    filteredQiyeData() {
      // 根据 filterActive 的值来过滤 qiyeData
      return this.qiyeData.filter(
        (item) => item.label_ids && item.label_ids.trim() !== ""
      );
    },
    isToken() {
        if (localStorage.getItem("token") && localStorage.getItem("token") != 'undefined' && localStorage.getItem("token").trim() != '') {
            return true
        } else {
            false
        }
    },
  },
  created() {
    if(this.isToken){
      this.getdata();
    }
  },
  methods: {
    wzxslist(item, index) {
      this.currentTab = index;
      this.typeid = item.id;
      this.getImg();
    },
    async getdata() {
      await this.getType();
      this.getImg();
    },
    getImg(){
      getExcelImg({ type: this.typeid }).then((res) => {
        console.log("123", res);
        this.pics = res.data;
      });
    },
    getType(){
      return new Promise((resolve,reject)=>{
        HqType().then((res) => {
          console.log("行情分类", res);
          this.hqtypes = res.data;
          this.typeid = res.data.length>0?res.data[0].id:1;
          resolve();
        });
      })
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  font-size: 2ch !important;
  color: #828689 !important;
  font-weight: 600 !important;
  text-align: left !important;
}
.data_brain_wrap {
  padding: 70px 0 70px 0;
  background: #e8eef2;
  // text-align: center;
  .brain_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40px;
    }
  }
  .fenlei {
    width: 100%;
    padding: 20px 10px;
    display: flex;
    // overflow-x: scroll;

    .fenleilist {
      height: 3vw;
      // width: 6vw;
      flex: 0 0 7vw;
      text-align: center;
      line-height: 3vw;
      color: #111;
      cursor: pointer;
      border-bottom: 1px solid #f9f9f9;
    }
    .fenleilist.active {
      height: 3vw;
      // width: 6vw;
      flex: 0 0 7vw;
      text-align: center;
      line-height: 3vw;
      color: #43afce;
      cursor: pointer;
      border-bottom: 2px solid #8e95b0;
    }
  }
  .card_wrap {
    width: 80%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-between;
    // height: 800px;
    border-radius: 8px;
    position: relative;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    .imgbox {
      width: 100%;
      height: 20vw;
      margin-bottom: 1vw;
    }
    .wzcontent {
      width: 100%;
      height: 10vw;
      overflow-y: scroll;
      font-size: 2ch;
      margin-bottom: 1vw;
      -ms-overflow-style: none; /* IE 和 Edge */
      scrollbar-width: none; /* Firefox */
    }
    .scrollable-container::-webkit-scrollbar {
      display: none; /* 隐藏滚动条 */
    }
    .page-content {
      width: 100%;
      height: 100%;
      padding: 5px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .fenlei {
        width: 100%;
        padding: 20px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .fenleilist {
          height: 2.5vw;
          width: 6vw;
          text-align: center;
          line-height: 2.5vw;
          background-color: #0d067e;
          color: #fff;
          border-radius: 5px;
          cursor: pointer;
        }
      }
    }
    .ggw {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 10%;
      width: 4%;
      margin-right: 1%;
    }
    .top-left {
      height: 100%;
      width: 20%;
      background-color: #0d067e;
      display: flex;
      flex-direction: column;
      border-radius: 6px;
      .top-left-title {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        color: #fff;
        padding: 10px 20px;
        font-weight: 700;
        font-size: 16px;
      }
      .top-left-info {
        width: 100%;
        flex: 1;
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;
        background-color: #fff;
        padding: 30px 20px;
        overflow-y: scroll;
        -ms-overflow-style: none; /* IE 和 Edge */
        scrollbar-width: none; /* Firefox */
      }
      .scrollable-container::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }
    }
    .top-center {
      height: 100%;
      width: 50%;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
    }
    .brain_item {
      transition: background-color 1s;
      padding: 30px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40px;
        border-radius: 10px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20px;
        &:nth-child(-n + 2) {
          margin-top: 0;
        }
      }
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;
      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          134deg,
          #0649b8 1%,
          #0a7fd7 41%,
          #03d2c5 99%
        );
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }
      &:hover .item_bg {
        opacity: 1;
      }
      &:hover .item_title {
        color: #fff;
      }
      &:hover .item_desc {
        color: #fff;
      }
      .item_title {
        transition: all 0.5s;
        font-size: 30px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 20px 0 40px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }
      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 18px;
        min-height: 110px;
        @media screen and (max-width: 768px) {
          min-height: 110px;
          text-indent: 2em;
          font-size: 12px;
        }
      }
      .item_navigate {
        width: 100px;
        height: 30px;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
